export const STREAMING = 'streaming'
export const REPLAY = 'replay'
export const MANUAL = 'manual'
export const MARKET = 'market'
export const SELLER = 'seller'
export const SUBSCRIPTION = 'subscription'
